var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-select"},[_c('p',{staticClass:"value"},[_vm._v("at Canmbridge")]),_c('ul',{staticClass:"list"},[_c('li')])])}]

export { render, staticRenderFns }